import type * as React from 'react'

function EstoniaFlag(props: React.SVGProps<SVGSVGElement>) {
  const topY = 4.13794
  const middleYStart = topY + 5.24142
  const bottomYStart = middleYStart + 5.24142

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.2026 19.8622H1.79742C0.804703 19.8622 0 19.0574 0 18.0647V5.93536C0 4.94264 0.804703 4.13794 1.79742 4.13794H22.2026C23.1952 4.13794 24 4.94264 24 5.93536V18.0647C24 19.0574 23.1953 19.8622 22.2026 19.8622Z"
        fill="#FFFFFF"
      />
      <path d={`M24 ${bottomYStart}H0V${middleYStart}H24V${bottomYStart}Z`} fill="#000000" />
      <path
        d={`M24 ${middleYStart}H0V5.93536C0 4.94264 0.804703 4.13794 1.79742 4.13794H22.2026C23.1952 4.13794 24 4.94264 24 5.93536V${middleYStart}Z`}
        fill="#0072CE"
      />
    </svg>
  )
}

export default EstoniaFlag
